// extracted by mini-css-extract-plugin
export default {"header":"commonLayout_header__vdPHP","MenuDrawer_container":"commonLayout_MenuDrawer_container__XMxlN"};